
import {forkJoin as observableForkJoin,  Observable } from 'rxjs';
import { Component, HostListener, OnInit } from '@angular/core';
import { NewsletterListService } from "app/newsletter/newsletter-list/newsletter-list.service";
import { MTemplateDataListResource } from "app/models/mtemplate-data-list-resource";
import { Router } from "@angular/router";
import { NotificationsService } from "angular2-notifications";
import { TranslateService } from "@ngx-translate/core";
import { UtilsService } from 'app/services/utils.service';

@Component({
  selector: 'vbn-newsletter-list',
  providers: [NewsletterListService],
  templateUrl: './newsletter-list.component.html',
  styleUrls: ['./newsletter-list.component.scss']
})
export class NewsletterListComponent implements OnInit {

  templateIdCrt: any;
  is4ExternalSubscriber: boolean;
  mTemplateDataListResource: MTemplateDataListResource;
  errorMessage: String;
  showConfirmation: boolean = false;
  userEmail: string;
  isOnResponsive: boolean = false;

  constructor(
    private translate: TranslateService,
    private newsletterListService: NewsletterListService,
    private router: Router,
    private service: UtilsService,
    private notificationService: NotificationsService) {
    this.mTemplateDataListResource = new MTemplateDataListResource();
    this.mTemplateDataListResource.templates = new Array();
    this.templateIdCrt = null;
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    const innerWidth = window.innerWidth;
    if (innerWidth <= 1100) {
      this.isOnResponsive = true;
    }
    else {
      this.isOnResponsive = false;
    }
  }

  ngOnInit() {
    this.userEmail = this.service.currentUserEmail;
    this.getNewsletters();
    if (innerWidth <= 1100) {
      this.isOnResponsive = true;
    }
    else {
      this.isOnResponsive = false;
    }
  }

  delete(elem) {
    elem.showDelete = true;
  }

  getNewsletters() {
    this.newsletterListService.getNewsletters()
      .subscribe(
      response => {
        console.log("Newsletter list: ", response)
        this.mTemplateDataListResource = response;
      },
      error => this.errorMessage = <any>error);
  }

  deleteTemplate(templateId) {
    this.newsletterListService.deleteTemplate(templateId)
      .subscribe(
      response => {
        console.log("Delete template: ", response)
        this.templateIdCrt = null;
        observableForkJoin(
          this.translate.get('Success'),
          this.translate.get('Newsletter was successfully deleted!')
        ).subscribe((res) => {
          this.notificationService.create(res[0], res[1], 'success')
        })
        // this.notificationService.create("Success", 'Newsletter was successfully deleted!', 'success')
        this.getNewsletters()
      },
      error => {
        this.errorMessage = <any>error
        observableForkJoin(
          this.translate.get('Error'),
          this.translate.get('Deleting could not be done')
        ).subscribe((res) => {
          this.notificationService.create(res[0], res[1], 'error')
        })
        // this.notificationService.create("Error", 'Deleting could not be done', 'error')
      });
  }
  confirmSave(templateId, isExternal) {
    this.templateIdCrt = templateId;
    this.is4ExternalSubscriber = isExternal;
    this.showConfirmation = true;
    console.log("test", this.showConfirmation);
  }

  sendMail() {
    this.newsletterListService.sendMail(this.templateIdCrt, this.is4ExternalSubscriber)
      .subscribe(
      response => {
        console.log("Send mail: ", response)

        if (response.errorCode == 7066) {
          observableForkJoin(
            this.translate.get('Error'),
            this.translate.get("Subscribers don't exists!")
          ).subscribe((res) => {
            this.notificationService.create(res[0], res[1], 'error')
          })
        }
        else {
          observableForkJoin(
            this.translate.get('Success'),
            this.translate.get('Email sent successfully!')
          ).subscribe((res) => {
            this.notificationService.create(res[0], res[1], 'success')
          })
        }
        // this.notificationService.create("Success", 'Email sent successfully!', 'success')


        this.getNewsletters()
      },
      error => {
        this.errorMessage = <any>error
        observableForkJoin(
          this.translate.get('Error'),
          this.translate.get('Email could not be sent!')
        ).subscribe((res) => {
          this.notificationService.create(res[0], res[1], 'error')
        })
        // this.notificationService.create("Error", 'Email could not be sent!', 'error')
      });
  }

  goToNewsletterAdd() {
    //localStorage.setItem('templateCreatedAdd', 'false');
    console.log("====>>> GO TO Newslwtter");
    this.router.navigateByUrl('/add-newsletter');
  }

  goToEdit(rid: number) {
    this.router.navigate(['/edit-newsletter/' + btoa('{ "newsletterRid" : "' + rid + '"}')]);
  }

  
  showResponsiveDetails(id) {
    const width = window.innerWidth;
    if (width <= 1100) {
      for (let i = 0; i < this.mTemplateDataListResource.templates.length; i++) {
        if (this.mTemplateDataListResource.templates[i].rid == id) {
          this.mTemplateDataListResource.templates[i].showDetailsOnResponsive = !this.mTemplateDataListResource.templates[i].showDetailsOnResponsive;
        }
        else {
          this.mTemplateDataListResource.templates[i].showDetailsOnResponsive = false;
        }
      }
    }
    else {
      return;
    }

  }
}
